import { Box } from "@mui/material";

import { Text } from "../components/Text";

export interface ChatMessageTimestampProps {
  senderName: string;
  timestamp: string;
}

export function ChatMessageTimestamp(props: ChatMessageTimestampProps) {
  const { senderName, timestamp } = props;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-end",
        gap: 2,
      }}
    >
      <Text
        inline
        variant="caption"
        sx={(theme) => ({
          color: theme.palette.base?.inactive, // 35% opacity per Figma
        })}
      >
        {senderName}
      </Text>
      <Text
        inline
        variant="overline"
        sx={(theme) => ({
          color: theme.palette.base?.inactive,
        })}
      >
        {timestamp}
      </Text>
    </Box>
  );
}
